'use client';

import Script from "next/script";
import { usePathname } from "next/navigation";

export const MicrosoftClarity = () => {
    const pathname = usePathname();
    const isMarketup = pathname?.startsWith('/marketup');
    const clarityId = isMarketup ? "vxh6mb5w7p" : "m17lmby6aa";

    return (
        <Script
            id={`microsoft-clarity-${clarityId}`}
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${clarityId}");
        `,
            }}
        />
    );
};
